import React from 'react';
import { Spinner, Container } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@context';

export function RequireAuth({ children }) {
  const { user, isAuthenticated, loading, logout } = useAuth();

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect suspended users to login
  if (user && user.isActive === false) {
    logout();
    return <Navigate to="/login" replace />;
  }

  return children;
}
